import React from 'react'

const Profile = () => {
  return (
    <div className='min-h-screen w-full flex items-center justify-center'>Profile</div>
  )
}

export default Profile